import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, withProps } from 'recompose'

import { nonBotUsers, orgUsersById } from 'app/modules/user/selectors'
import { draftId } from 'app/modules/playbook/selectors'
import * as PlaybookActions from 'app/modules/playbook/actions'

import SequenceInviteModal from './component'

const mapStateToProps = state => ({
  users: orgUsersById(state),
  nonBotUsers: nonBotUsers(state),
  draftId: draftId(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    hideSequenceInviteModal: PlaybookActions.hideSequenceInviteModal,
    notify: PlaybookActions.notify,
  }, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props => ({
    options: props.nonBotUsers
      .toArray()
      .map(user => ({ value: user.id, label: user.name || user.email })),
  })),
  withHandlers({
    onCloseClick: props => () => props.actions.hideSequenceInviteModal(),
    onNext: props => userIds => {
      props.actions.hideSequenceInviteModal()
      props.actions.notify({ userIds, playbookId: props.draftId })
    },
  }),
)(SequenceInviteModal)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/SequenceInviteModal/index.js